// extracted by mini-css-extract-plugin
export default {"inputContainer":"LabelTextInput_inputContainer__nYJ75","textInput":"LabelTextInput_textInput__4ie5D"};